'use strict';

var GetIntrinsic = require('../GetIntrinsic');

var $Object = GetIntrinsic('%Object%');

var isPrimitive = require('../helpers/isPrimitive');

var $preventExtensions = $Object.preventExtensions;
var $isExtensible = $Object.isExtensible; // https://www.ecma-international.org/ecma-262/6.0/#sec-isextensible-o

module.exports = $preventExtensions ? function IsExtensible(obj) {
  return !isPrimitive(obj) && $isExtensible(obj);
} : function IsExtensible(obj) {
  // eslint-disable-line no-unused-vars
  return true;
};